export default {
  methods: {
    $_image_path() {
      return window.location.origin.includes('localhost') ? 'http://127.0.0.1:8000/images/' : window.location.origin + '/images/'
    },

    $_has_perm(permissionCode) {
      const authUserPermissions = JSON.parse(localStorage.getItem('user_permissions'))

      for (const index in authUserPermissions) {
        if (permissionCode === authUserPermissions[index].code) {
          return true
        }
      }

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js